import { render, staticRenderFns } from "./DataListItems.vue?vue&type=template&id=3e543297&scoped=true&"
import script from "./DataListItems.vue?vue&type=script&lang=js&"
export * from "./DataListItems.vue?vue&type=script&lang=js&"
import style0 from "./DataListItems.vue?vue&type=style&index=0&id=3e543297&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e543297",
  null
  
)

export default component.exports